import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable()
export class GetParameterService {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) { }

  getParameter(parameterName: string) {

    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    var headers = new HttpHeaders({'Content-Type': 'application/json'})
      .set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');

    var params = new HttpParams();

    params = params.set("parameterName", parameterName);
    

    return this.httpClient.get(`${apiConfig.uri}/Parameters`, { headers: headers, params : params });
  }
}
